import * as Sentry from "@sentry/react";
import { useEffect } from 'react';
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router-dom';


export const initSentry = (production: boolean, dsn: string, tracePropagationTargets: any[] = []) => {
  Sentry.init({
    dsn,
    beforeSend(event) {
      const frames = event.exception?.values?.[0]?.stacktrace?.frames || [];

      const isThirdParty = frames.some(f =>
        f.filename && !f.filename.includes(window.location.hostname)
      );

      if (isThirdParty) {
        return null;
      }

      // Drop errors from GTM/inline scripts where frames have no filename
      // (e.g. unresolved GTM placeholder variables like Replace_with_Variable_*)
      const hasOnlyAnonymousFrames = frames.length > 0 && frames.every(f => !f.filename);
      if (hasOnlyAnonymousFrames) {
        return null;
      }

      return event;
    },
    integrations: [
      // See docs for support of different versions of variation of react router
      // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      Sentry.replayIntegration(),
    ],
    environment: production ? 'production' : 'develop',
    // Performance Monitoring
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets,
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}
